const HRN_LEVEL_LABELS = {
  0: 'Conforme',
  1: 'Aceitável',
  2: 'Muito Baixo',
  3: 'Baixo',
  4: 'Significante',
  5: 'Alto',
  6: 'Muito Alto',
  7: 'Extremo',
  8: 'Inaceitável',
}

const HRN_LEVEL_COLORS = {
  0: '#abd4ff',
  1: '#C3FFC1',
  2: '#C3FFC1',
  3: '#FDF55F',
  4: '#FDF55F',
  5: '#F81C19',
  6: '#F81C19',
  7: '#F81C19',
  8: '#000',
}

export { HRN_LEVEL_LABELS, HRN_LEVEL_COLORS }
